import React, {useContext} from "react";
import {Route, Redirect} from "react-router-dom";
import { Auth } from "store";

const AuthRoute : React.FC<any> = ({ component : Component , ...rest  }) => {

    const {authenticated } = useContext(Auth);

    return (
        <Route
            {...rest}
            render={props => {
                return authenticated
                    ? <Component {...props} />
                    : <Redirect to={"/"}/>
            }}
        />
    )
};

export default AuthRoute;
